import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { AddToCalendarService } from 'src/app/services/AddToCalendar/add-to-calendar.service';
import { ApiService, Show } from 'src/app/services/api/api.service';
import { gsap, Expo, Quad } from 'gsap';

@Component({
  selector: 'app-poster-card',
  templateUrl: './poster-card.component.html',
  styleUrls: ['./poster-card.component.scss']
})
export class PosterCardComponent {
    @Input('show') show: Show
    @Input('color1') color1: string
    @Input('color2') color2: string
    @Input('color3') color3: string
    @Input('color4') color4: string
    @Input('channel') channel : string

    @ViewChild('btn', { static: false })
    private _btn: ElementRef | undefined;
    public get btn(): ElementRef | undefined {
        return this._btn;
    }
    public set btn(value: ElementRef | undefined) {
        this._btn = value;
        
    }

    constructor(
        private apiService: ApiService,
        private addToCalendarService: AddToCalendarService
    ) {
        
    }

    ngAfterViewInit() {
        setTimeout(() => {
            gsap.set(this.btn.nativeElement, {backgroundColor: this.color1, color: this.color4});
        }, 100);
    }

    addToCalendar() {
        this.addToCalendarService.reset()

        if(!this.show.manual) {

            let list = this.apiService.getAllTitles(this.show.title);
            list.forEach((item) => {
    
                
                // var desc = this.channel +  '\\n' + this.show.description
                var desc = this.show.description + '\\n\\n' + '-Watch On '+ this.channel.toUpperCase() +' Channel'
    
                this.addToCalendarService.addEvent(this.show.title, desc, "", item.start.toDate().toUTCString(), item.end.toDate().toUTCString(), window.location.href);
    
                
            })
        }
        else {
            var desc = this.show.description + '\\n\\n' + '-Watch On '+ this.channel.toUpperCase() +' Channel'
    
            this.addToCalendarService.addEvent(this.show.title, desc, "", this.show.start.toDate().toUTCString(), this.show.end.toDate().toUTCString(), window.location.href);
        }

        this.addToCalendarService.download(this.show.programId, 'ics')

    }

    onOver(e: Event) {
        // console.log('over' + e.target)
        gsap.to(e.target, 0.3, {backgroundColor: this.color2, color: this.color3});

    }

    onOut(e: Event) {
        // console.log('out')
        gsap.to(e.target, 0.3, {backgroundColor: this.color1, color: this.color4});
    }
}
